import {connect} from 'react-redux';

import {AppState} from '../../../../../../../../../../src/store/appState';
import {deleteCardsAsyncAction} from '../../../../../../../../../../src/store/data/cards/cardsActions';
import {makeGetCards} from '../../../../../../../../../../src/store/data/cards/cardsSelectors';
import {contactsManagerTableRemoveCardIdRefsAction} from '../../../../../../../../../../src/store/panels/contacts/contactsManager/table/contactsManagerTableActions';
import {ContactsManagerPanelId} from '../../../../../../../../../../src/store/panels/panelStateBase';
import {
  makeMapDispatchToProps,
  makeMapStateToProps,
} from '../../../../../../../../../../srcCommon/helpers/reselectHelpers';
import {ContactsTableMultiDeleteAction} from './contactsTableMultiDeleteAction';

/*
 * Props.
 */

interface ContactsTableMultiDeleteActionContainerProps {
  cardIds: ReadonlyArray<number>;
  panelId: ContactsManagerPanelId;
}

/*
 * Selectors.
 */

function getCardIds(_state: AppState, props: ContactsTableMultiDeleteActionContainerProps) {
  return props.cardIds;
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<ContactsTableMultiDeleteActionContainerProps>()(() => ({
  cards: makeGetCards(getCardIds),
}));

const mapDispatchToProps = makeMapDispatchToProps<ContactsTableMultiDeleteActionContainerProps>()(
  ({panelId}) => ({
    deleteCardsAsync: deleteCardsAsyncAction,
    onDeleteSuccess: (cardIds: ReadonlyArray<number>) =>
      contactsManagerTableRemoveCardIdRefsAction(panelId, cardIds),
  }),
);

export const ContactsTableMultiDeleteActionContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ContactsTableMultiDeleteAction);
